import { Protocol } from '../Protocol';

export class MixerProportionProtocol {
  public static readonly GET_MIXER_PROP_SETTING: string = `${Protocol.YATUNG_API_ROOT}/mixer/mixer-prop-setting/all`;
  public static readonly PUT_MIXER_PROP_SETTING: string = `${Protocol.YATUNG_API_ROOT}/mixer/mixer-prop-setting`;
}
